const invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
const ctrlCharactersRegex =
  /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
const urlSchemeRegex = /^([^:]+):/gm;
const relativeFirstCharacters = [".", "/"];
const stringsToRemove = ['<script>', '</script>', '</', 'alert(', '<', '>'];

function removeAlert(url = '') {
    let decodedUrl = decodeURIComponent(url);
    stringsToRemove.forEach(item => {
        const itemRemoved = decodedUrl.split(item);
        decodedUrl = itemRemoved.join('');
    });
    return decodedUrl;
}

function isRelativeUrlWithoutProtocol(url = '') {
  return relativeFirstCharacters.indexOf(url[0]) > -1;
}

const sanitizeUrl = (url = '') => {
  if (!url) {
    return "about:blank";
  }

  const sanitizedUrl = url.replace(ctrlCharactersRegex, "").trim();

  if (isRelativeUrlWithoutProtocol(sanitizedUrl)) {
    return removeAlert(sanitizedUrl);
  }

  const urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);

  if (!urlSchemeParseResults) {
    return removeAlert(sanitizedUrl);
  }

  const urlScheme = urlSchemeParseResults[0];

  if (invalidProtocolRegex.test(urlScheme)) {
    return "about:blank";
  }

  return removeAlert(sanitizedUrl);
}

export default sanitizeUrl;